<template>
    <v-flex xs12>
        <v-layout>
            <v-flex xs6>
                <h3>Permisos de Rutas</h3>
                <v-select :items="users" v-model="user" label="Elija usuario" single-line bottom item-text="name"
                          item-value="id"></v-select>
                <v-list two-line>
                    <template v-for="r in rutas">
                        <v-list-group v-if="r.children" no-action>
                            <v-list-tile slot="item" @click="">
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ r.nombre }}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ r.path }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <v-icon>keyboard_arrow_up</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>
                            <template v-for="(child, i) in r.children" @click="">
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-checkbox v-model="asignar" :value="r.path + child.path"></v-checkbox>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ child.nombre }}</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ child.path }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-divider></v-divider>
                            </template>
                        </v-list-group>
                        <v-list-tile v-else @click="">
                            <v-list-tile-action>
                                <v-checkbox v-model="asignar" :value="r.path"></v-checkbox>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>{{ r.nombre }}</v-list-tile-title>
                                <v-list-tile-sub-title>{{ r.path }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-divider></v-divider>
                    </template>
                </v-list>
                <v-btn @click.native="permission">Asignar</v-btn>
                <v-btn @click.native="permissionUpdate">Actualizar</v-btn>
            </v-flex>
        </v-layout>
    </v-flex>
</template>
<script>
    import usersMixin from '../../mixins/auth/users'

    export default {
        name: 'permisos',
        mixins: [usersMixin],
        data() {
            return {
                user: '',
                users: [],
                asignar: [],
                rutas: this.$router.options.routes
            }
        },
        mounted() {
            this.getUsers(r => {
                this.users = r
            }, err => {
                alert(err)
            })
        },
        methods: {
            permissionUpdate() {
                this.$http.post('permission-update', {permisos: this.rutas})
                    .then(r => {
                        this.loading = false;
                    }, r => {
                        this.loading = false;
                    });
            },
            attachPermission() {
                this.$http.post('attach-permission', {})
                    .then(r => {
                        this.loading = false;
                    }, r => {
                        this.loading = false;
                    });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/auth/permisos.vue